<div *tdWbIfNoFeature="'whatsNewModalWisc2UIMigration'">
  <td-wb-modal-notification-deprecated [triggerId]="triggerId()" />
</div>

<div *tdWbIfFeature="'whatsNewModalWisc2UIMigration'">
  @if (isWelcomeModal()) {
    <td-wb-modal-notification-welcome [modalId]="triggerId()" />
  } @else if (isWhatsNewModal()) {
    <td-wb-modal-notification-whats-new />
  } @else {
    <td-wb-modal-notification-deprecated [triggerId]="triggerId()" />
  }
</div>
